document.addEventListener('DOMContentLoaded',function(){
  var nav=document.querySelector('.tbmm-bottom-nav');
  if(!nav)return;
  var path=window.location.pathname.replace(/\/$/,'')||'/';
  var links=nav.querySelectorAll('a');
  links.forEach(function(a){a.removeAttribute('aria-current')});
  var target=null;
  if(path==='/') target=links[0];
  else if(path==='/collections/selling-fast-on-trenbee') target=links[1];
  else if(path==='/collections/one-day-dispatch') target=links[2];
  else if(path==='/collections' || path.indexOf('/collections/')===0) target=links[3];
  else if(path.indexOf('/account')===0) target=links[4];
  if(target) target.setAttribute('aria-current','page');
});
